export const WEBSITE_THEMES = [
  {
    // ── Aman universe theme — deep black, warm linen, #C4956A gold, Cormorant Garamond ──
    // This entry is written when the couple selects the Aman universe. It faithfully
    // expresses Aman's identity (dark bg, gold accent) inside the existing theme system
    // so MultiPageWeddingWebsite renders it without any changes to its read path.
    id: 'aman',
    name: 'Aman',
    mood: 'Quiet Luxury',
    darkBg: '#0A0A0A',
    lightBg: '#F8F7F5',
    darkText: '#F8F7F5',
    lightText: '#0A0A0A',
    accent: '#C4956A',
    accentSecondary: '#8B6340',
    navBg: '#0A0A0A',
  },
  {
    id: 'still',
    name: 'Still',
    mood: 'Quiet Luxury',
    darkBg: '#0A0A0A',
    lightBg: '#F8F7F5',
    darkText: '#FFFFFF',
    lightText: '#0A0A0A',
    accent: '#FFFFFF',
    accentSecondary: '#888888',
    navBg: '#0A0A0A'
  },
  {
    id: 'dusk',
    name: 'Dusk',
    mood: 'Golden Hour',
    darkBg: '#1C1410',
    lightBg: '#F5F0EA',
    darkText: '#F5F0EA',
    lightText: '#1C1410',
    accent: '#C4956A',
    accentSecondary: '#8B6340',
    navBg: '#1C1410'
  },
  {
    id: 'sage',
    name: 'Sage',
    mood: 'Garden Party',
    darkBg: '#1A2018',
    lightBg: '#F4F6F0',
    darkText: '#F4F6F0',
    lightText: '#1A2018',
    accent: '#7A9E7E',
    accentSecondary: '#4A6B4E',
    navBg: '#1A2018'
  },
  {
    id: 'slate',
    name: 'Slate',
    mood: 'Modern Love',
    darkBg: '#141820',
    lightBg: '#F0F2F5',
    darkText: '#F0F2F5',
    lightText: '#141820',
    accent: '#6B7FA3',
    accentSecondary: '#3D5278',
    navBg: '#141820'
  },
  {
    id: 'blush',
    name: 'Blush',
    mood: 'Romance',
    darkBg: '#1E1418',
    lightBg: '#FBF5F5',
    darkText: '#FBF5F5',
    lightText: '#1E1418',
    accent: '#C4768A',
    accentSecondary: '#8B4560',
    navBg: '#1E1418'
  },
  {
    id: 'noir',
    name: 'Noir',
    mood: 'Editorial',
    darkBg: '#0A0A0A',
    lightBg: '#FFFFFF',
    darkText: '#FFFFFF',
    lightText: '#0A0A0A',
    accent: '#E03553',
    accentSecondary: '#803D81',
    navBg: '#0A0A0A'
  },
  {
    id: 'ivory',
    name: 'Ivory',
    mood: 'Classic Elegance',
    darkBg: '#1A1814',
    lightBg: '#FAF8F3',
    darkText: '#FAF8F3',
    lightText: '#1A1814',
    accent: '#D4C5A9',
    accentSecondary: '#9B8B6E',
    navBg: '#1A1814'
  },
  {
    id: 'midnight',
    name: 'Midnight',
    mood: 'Dark Romance',
    darkBg: '#080B14',
    lightBg: '#F0F2F8',
    darkText: '#F0F2F8',
    lightText: '#080B14',
    accent: '#8B9FD4',
    accentSecondary: '#4A5F9E',
    navBg: '#080B14'
  },
  {
    id: 'terra',
    name: 'Terra',
    mood: 'Earth & Stone',
    darkBg: '#1A1208',
    lightBg: '#F5EFE6',
    darkText: '#F5EFE6',
    lightText: '#1A1208',
    accent: '#B8856A',
    accentSecondary: '#7A4F35',
    navBg: '#1A1208'
  },
  {
    id: 'forest',
    name: 'Forest',
    mood: 'Into the Woods',
    darkBg: '#0E1A10',
    lightBg: '#EFF4EC',
    darkText: '#EFF4EC',
    lightText: '#0E1A10',
    accent: '#5C8B5E',
    accentSecondary: '#2D5530',
    navBg: '#0E1A10'
  },
  {
    id: 'coral',
    name: 'Coral',
    mood: 'Sunset',
    darkBg: '#1A0E0A',
    lightBg: '#FFF3EE',
    darkText: '#FFF3EE',
    lightText: '#1A0E0A',
    accent: '#E8826A',
    accentSecondary: '#B85540',
    navBg: '#1A0E0A'
  },
  {
    id: 'lavender',
    name: 'Lavender',
    mood: 'Dreamy',
    darkBg: '#12101A',
    lightBg: '#F5F2FA',
    darkText: '#F5F2FA',
    lightText: '#12101A',
    accent: '#9B8EC4',
    accentSecondary: '#6B5A9E',
    navBg: '#12101A'
  },
  {
    id: 'bronze',
    name: 'Bronze',
    mood: 'Antique',
    darkBg: '#140E08',
    lightBg: '#F5EFE0',
    darkText: '#F5EFE0',
    lightText: '#140E08',
    accent: '#B8955A',
    accentSecondary: '#7A5E30',
    navBg: '#140E08'
  },
  {
    id: 'arctic',
    name: 'Arctic',
    mood: 'Ice & Snow',
    darkBg: '#0A1018',
    lightBg: '#F0F5FA',
    darkText: '#F0F5FA',
    lightText: '#0A1018',
    accent: '#A8C4D8',
    accentSecondary: '#5A8BAA',
    navBg: '#0A1018'
  },
  {
    id: 'desert',
    name: 'Desert',
    mood: 'Sand Dunes',
    darkBg: '#1A1408',
    lightBg: '#F8F2E8',
    darkText: '#F8F2E8',
    lightText: '#1A1408',
    accent: '#D4AA70',
    accentSecondary: '#9B7040',
    navBg: '#1A1408'
  },
  {
    id: 'plum',
    name: 'Plum',
    mood: 'Deep Purple',
    darkBg: '#140A18',
    lightBg: '#F5F0F8',
    darkText: '#F5F0F8',
    lightText: '#140A18',
    accent: '#9B6AB8',
    accentSecondary: '#6B3A8B',
    navBg: '#140A18'
  },
  {
    id: 'jade',
    name: 'Jade',
    mood: 'Eastern Garden',
    darkBg: '#081410',
    lightBg: '#EEF6F2',
    darkText: '#EEF6F2',
    lightText: '#081410',
    accent: '#5A9E8A',
    accentSecondary: '#2D6B58',
    navBg: '#081410'
  },
  {
    id: 'charcoal',
    name: 'Charcoal',
    mood: 'Industrial',
    darkBg: '#111111',
    lightBg: '#F5F5F5',
    darkText: '#F5F5F5',
    lightText: '#111111',
    accent: '#888888',
    accentSecondary: '#444444',
    navBg: '#111111'
  },
  {
    id: 'champagne',
    name: 'Champagne',
    mood: 'Celebration',
    darkBg: '#181410',
    lightBg: '#FDF9F0',
    darkText: '#FDF9F0',
    lightText: '#181410',
    accent: '#D4B896',
    accentSecondary: '#A8845A',
    navBg: '#181410'
  },
  {
    id: 'obsidian',
    name: 'Obsidian',
    mood: 'Volcanic',
    darkBg: '#050505',
    lightBg: '#F8F8F8',
    darkText: '#F8F8F8',
    lightText: '#050505',
    accent: '#E03553',
    accentSecondary: '#6B2CAE',
    navBg: '#050505'
  }
];

export const TYPOGRAPHY_PAIRINGS = [
  {
    id: 'classic',
    name: 'Classic',
    description: 'Timeless elegance',
    fontDisplay: '"Cormorant Garamond", serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: 'Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400',
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Contemporary romance',
    fontDisplay: '"DM Serif Display", serif',
    fontBody: '"DM Sans", sans-serif',
    googleFonts: 'DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500',
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Clean and confident',
    fontDisplay: '"Plus Jakarta Sans", sans-serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: '',
  },
  {
    id: 'editorial',
    name: 'Editorial',
    description: 'Magazine luxury',
    fontDisplay: '"Playfair Display", serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: 'Playfair+Display:ital,wght@0,400;0,700;1,400;1,700',
  },
  {
    id: 'literary',
    name: 'Literary',
    description: 'Poetic and literary',
    fontDisplay: '"Lora", serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: 'Lora:ital,wght@0,400;0,600;1,400;1,600',
  },
  {
    id: 'bold',
    name: 'Bold',
    description: 'Strong statement',
    fontDisplay: '"Fraunces", serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: 'Fraunces:ital,wght@0,300;0,700;1,300;1,700',
  },
  {
    id: 'handcrafted',
    name: 'Handcrafted',
    description: 'Artisan warmth',
    fontDisplay: '"Rozha One", serif',
    fontBody: '"Jost", sans-serif',
    googleFonts: 'Rozha+One&family=Jost:wght@300;400;500',
  },
  {
    id: 'luxe',
    name: 'Luxe',
    description: 'Opulent ceremony',
    fontDisplay: '"Bodoni Moda", serif',
    fontBody: '"Plus Jakarta Sans", sans-serif',
    googleFonts: 'Bodoni+Moda:ital,wght@0,400;0,600;1,400',
  },
  {
    id: 'romantic',
    name: 'Romantic',
    description: 'Soft and romantic',
    fontDisplay: '"Libre Baskerville", serif',
    fontBody: '"Nunito", sans-serif',
    googleFonts: 'Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito:wght@300;400;500',
  },
  {
    id: 'geometric',
    name: 'Geometric',
    description: 'Architectural precision',
    fontDisplay: '"Josefin Sans", sans-serif',
    fontBody: '"Josefin Sans", sans-serif',
    googleFonts: 'Josefin+Sans:ital,wght@0,100;0,300;0,400;1,100;1,300',
  },
  {
    id: 'vintage',
    name: 'Vintage',
    description: 'Heritage and charm',
    fontDisplay: '"Abril Fatface", serif',
    fontBody: '"Crimson Text", serif',
    googleFonts: 'Abril+Fatface&family=Crimson+Text:ital,wght@0,400;0,600;1,400',
  },
  {
    id: 'ethereal',
    name: 'Ethereal',
    description: 'Light and dreamy',
    fontDisplay: '"Gilda Display", serif',
    fontBody: '"Raleway", sans-serif',
    googleFonts: 'Gilda+Display&family=Raleway:wght@300;400;500',
  },
  {
    id: 'cinematic',
    name: 'Cinematic',
    description: 'Film and drama',
    fontDisplay: '"Bebas Neue", sans-serif',
    fontBody: '"Karla", sans-serif',
    googleFonts: 'Bebas+Neue&family=Karla:wght@300;400;500',
  },
  {
    id: 'garden',
    name: 'Garden',
    description: 'Natural and organic',
    fontDisplay: '"Marcellus", serif',
    fontBody: '"Jost", sans-serif',
    googleFonts: 'Marcellus&family=Jost:wght@300;400;500',
  },
  {
    id: 'highfashion',
    name: 'High fashion',
    description: 'Runway elegance',
    fontDisplay: '"Didact Gothic", sans-serif',
    fontBody: '"Inter", sans-serif',
    googleFonts: 'Didact+Gothic&family=Inter:wght@300;400;500',
  },
].map(t => ({
  ...t,
  // Aliases used by MultiPageWeddingWebsite + all guest-site page components
  headingFont: t.fontDisplay,
  bodyFont: t.fontBody,
  headingWeight: 400,
  headingStyle: 'normal',
  bodyWeight: 400,
  headingImport: t.googleFonts
    ? `@import url('https://fonts.googleapis.com/css2?family=${t.googleFonts}&display=swap');`
    : '',
  bodyImport: '',
}));

export const TRANSITION_OPTIONS = [
  { id: 'fade', name: 'Fade', mood: 'Gentle', description: 'Pages fade in/out, opacity only' },
  { id: 'slide', name: 'Slide', mood: 'Flowing', description: 'Pages slide horizontally' },
  { id: 'reveal', name: 'Reveal', mood: 'Cinematic', description: 'Dark overlay sweeps revealing new page' },
  { id: 'dissolve', name: 'Dissolve', mood: 'Dreamy', description: 'Cross-fade with slight scale' }
];

export const SCROLL_ANIMATION_OPTIONS = [
  { id: 'none', name: 'None', mood: 'Instant', description: 'Content appears immediately' },
  { id: 'subtle', name: 'Subtle', mood: 'Refined', description: 'Gentle fade-up, default experience' },
  { id: 'dramatic', name: 'Dramatic', mood: 'Immersive', description: 'Slower reveal, slight blur clear' }
];

export const HERO_EFFECT_OPTIONS = [
  { id: 'parallax', name: 'Parallax', description: 'Photo moves at 0.5x scroll speed' },
  { id: 'zoomout', name: 'Zoom Out', description: 'Photo slowly zooms out as user scrolls' },
  { id: 'static', name: 'Static', description: 'No movement, clean and still' }
];

export const FONT_OPTIONS = [
  { label: 'Cormorant Garamond', value: '"Cormorant Garamond", serif', google: 'Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400' },
  { label: 'Playfair Display', value: '"Playfair Display", serif', google: 'Playfair+Display:ital,wght@0,400;0,700;1,400' },
  { label: 'DM Serif Display', value: '"DM Serif Display", serif', google: 'DM+Serif+Display:ital@0;1' },
  { label: 'Lora', value: '"Lora", serif', google: 'Lora:ital,wght@0,400;0,600;1,400' },
  { label: 'Fraunces', value: '"Fraunces", serif', google: 'Fraunces:ital,wght@0,300;0,700;1,400' },
  { label: 'Libre Baskerville', value: '"Libre Baskerville", serif', google: 'Libre+Baskerville:ital,wght@0,400;0,700;1,400' },
  { label: 'Bodoni Moda', value: '"Bodoni Moda", serif', google: 'Bodoni+Moda:ital,wght@0,400;0,600;1,400' },
  { label: 'Rozha One', value: '"Rozha One", serif', google: 'Rozha+One' },
  { label: 'Marcellus', value: '"Marcellus", serif', google: 'Marcellus' },
  { label: 'Abril Fatface', value: '"Abril Fatface", serif', google: 'Abril+Fatface' },
  { label: 'Gilda Display', value: '"Gilda Display", serif', google: 'Gilda+Display' },
  { label: 'Plus Jakarta Sans', value: '"Plus Jakarta Sans", sans-serif', google: '' },
  { label: 'DM Sans', value: '"DM Sans", sans-serif', google: 'DM+Sans:wght@300;400;500' },
  { label: 'Josefin Sans', value: '"Josefin Sans", sans-serif', google: 'Josefin+Sans:wght@100;300;400' },
  { label: 'Raleway', value: '"Raleway", sans-serif', google: 'Raleway:wght@300;400;500' },
  { label: 'Jost', value: '"Jost", sans-serif', google: 'Jost:wght@300;400;500' },
  { label: 'Nunito', value: '"Nunito", sans-serif', google: 'Nunito:wght@300;400;500' },
  { label: 'Karla', value: '"Karla", sans-serif', google: 'Karla:wght@300;400;500' },
  { label: 'Inter', value: '"Inter", sans-serif', google: 'Inter:wght@300;400;500' },
  { label: 'Bebas Neue', value: '"Bebas Neue", sans-serif', google: 'Bebas+Neue' },
];

export const WEDDING_PAGES = [
  { slug: 'home', label: 'Home', icon: 'LayoutDashboard' },
  { slug: 'our-story', label: 'Our Story', icon: 'BookOpen' },
  { slug: 'celebration', label: 'Celebration', icon: 'Star' },
  { slug: 'rsvp', label: 'RSVP', icon: 'Mail' },
  { slug: 'registry', label: 'Registry', icon: 'Gift' },
  { slug: 'music', label: 'Music', icon: 'Music' },
  { slug: 'photos', label: 'Photos', icon: 'Camera' },
  { slug: 'styling', label: 'Styling', icon: 'Sparkles' },
  { slug: 'polls', label: 'Polls', icon: 'BarChart2' },
  { slug: 'faq', label: 'FAQ', icon: 'HelpCircle' },
  { slug: 'stay', label: 'Stay', icon: 'Hotel' },
  { slug: 'transport', label: 'Getting here', icon: 'Car' },
  { slug: 'experience', label: 'Guide', icon: 'Compass' },
];
// ── Universe identity configs — texture + motion per universe ─────────────────
// Static, code-defined (not stored in DB — these are per-universe constants).
// Only AMAN has real values for now; others get undefined (flat behaviour).
// Later phases: each universe declares its own texture + motion philosophy.
export const UNIVERSE_CONFIGS = {
  aman: {
    texture: {
      type:    'grain',   // SVG feTurbulence fractalNoise overlay on dark sections
      opacity: 0.025,     // 2.5% — barely-there; visible on close inspection, not at a glance
    },
    motion: {
      sectionReveal: 'fade',   // type: fade-up on viewport entry
      duration:      0.75,     // 750ms — gentle, unhurried
      yOffset:       18,       // px rise — perceptible gentle lift on scroll entry
      ease:          'easeOut',// soft stop
      intensity:     'subtle', // semantic flag for future tuning
    },
    pageTransition: {
      type:     'fade',
      duration: 0.65,    // 650ms — clearly a deliberate soft fade (exit+enter = ~1.3s total)
    },
  },
  // tulum, kyoto, capri, tokyo, marrakech, paris, amalfi, sedona, aspen, santorini:
  // not yet defined — they inherit flat/default behaviour until their phase.
};
